import type { ITransactionItemResources } from "./TransactionItem.Resources";

export const TransactionItemResourcesEn: ITransactionItemResources = {
    orderIdMobileLabel: "ORDER NUMBER",
    complaintStatusLabel: "Latest request status:",
    purchaseAmountLabel: "PURCHASES VALUE",
    btnText: "Send a request",
    btnTextAgain: "SEND NEW REQUEST",
    accountNumberLabel: "Account Number:",
    recipientLabel: "Recipient:",
    trxConditionsLabel: "BONUS APPROVAL CONDITIONS",
};
